import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../../contexts/LanguageContext';
import Navbar from '../../Layout/Navbar';
import Footer from '../../Layout/Footer';
import './ServiceDetail.css';
import Privatimg from './privat.png';

const PrivateCleaning = () => {
  const { t } = useLanguage();

  return (
    <div className="service-detail-page">
      <Navbar />

      <section className="service-hero">
        <div className="container">
          <h1>{t('services.privateCleaning.title', 'Private Cleaning Services')}</h1>
          <p>{t('services.privateCleaning.subtitle', 'Professional residential cleaning tailored to your home')}</p>
        </div>
      </section>

      <section className="service-content-section">
        <div className="container">
          <div className="service-detail-content">
            <div className="service-detail-image">
              <img src={Privatimg} alt="Private Cleaning" />
            </div>

            <div className="service-detail-text">
              <h2>{t('services.privateCleaning.heading', 'Comprehensive Home Cleaning Solutions')}</h2>
              <p>
                {t('services.privateCleaning.description', 'Our private cleaning services are designed to keep your home spotless and comfortable. We understand that every home is unique, which is why we offer customizable cleaning plans that fit your specific needs and schedule.')}
              </p>

            

              <h3>{t('services.privateCleaning.whatWeInclude', 'What We Include')}</h3>
              <ul className="service-features">
                <li>{t('services.privateCleaning.features.kitchen', 'Kitchen cleaning including appliances, countertops, and cabinets')}</li>
                <li>{t('services.privateCleaning.features.bathroom', 'Bathroom sanitization and deep cleaning')}</li>
                <li>{t('services.privateCleaning.features.dusting', 'Dusting and polishing of all surfaces')}</li>
                <li>{t('services.privateCleaning.features.floors', 'Vacuuming and mopping of all floors')}</li>
                <li>{t('services.privateCleaning.features.trash', 'Trash removal and recycling')}</li>
                <li>{t('services.privateCleaning.features.windows', 'Window and mirror cleaning')}</li>
                <li>{t('services.privateCleaning.features.baseboards', 'Baseboard and door frame cleaning')}</li>
                <li>{t('services.privateCleaning.features.lights', 'Light fixture cleaning')}</li>
              </ul>

            

              <h3>{t('services.privateCleaning.serviceOptions', 'Service Options')}</h3>
              <div className="service-options">
                <div className="service-option-card">
                  <h4>{t('services.privateCleaning.regularMaintenance.title', 'Regular Maintenance')}</h4>
                  <p>{t('services.privateCleaning.regularMaintenance.description', 'Weekly, bi-weekly, or monthly cleaning to keep your home consistently clean and organized.')}</p>
                </div>
                <div className="service-option-card">
                  <h4>{t('services.privateCleaning.deepCleaning.title', 'Deep Cleaning')}</h4>
                  <p>{t('services.privateCleaning.deepCleaning.description', 'Thorough cleaning of every corner, including hard-to-reach areas and detailed attention to all surfaces.')}</p>
                </div>
                <div className="service-option-card">
                  <h4>{t('services.privateCleaning.oneTime.title', 'One-Time Cleaning')}</h4>
                  <p>{t('services.privateCleaning.oneTime.description', 'Perfect for special occasions, after parties, or when you need a fresh start.')}</p>
                </div>
              </div>

              <h3>{t('services.privateCleaning.whyChoose', 'Why Choose Our Private Cleaning Service?')}</h3>
              <p>
                {t('services.privateCleaning.whyChooseText', 'Our team of experienced cleaners is trained in the latest cleaning techniques and uses eco-friendly products that are safe for your family and pets. We\'re fully insured and bonded, giving you peace of mind. All our cleaners undergo thorough background checks and are committed to providing exceptional service. We respect your home and privacy, working efficiently while you\'re away or at your convenience.')}
              </p>

              <div className="service-cta">
                <Link to="/contact" className="btn btn-primary">{t('services.getQuote', 'Get a Quote')}</Link>
                <Link to="/" className="btn btn-secondary">{t('services.backToServices', 'Back to Services')}</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PrivateCleaning;
